/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React from 'react';
import {
    object,
} from 'prop-types';
import loadable from '@loadable/component';
import mbpLogger from '@module-logger/mbp';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Link } from 'react-router-dom';
import styles from './Short.module.css';
import ResponsiveWrapper from '../../../../../SubComponents/ResponsiveWrapper';
import universalHandleClick from '../../../../../UniversalHandleClick';
import ConditionalWrapper from '../../../../ConditionalWrapper';

const MessageStandard = loadable(() => import(/* webpackChunkName: "MessageStandard" */ '../../../../../SubComponents/Message/MessageStandard'));

const ShortBanner = ({ data, salesforceResponse }) =>     {
    if (!Object.keys(data || {})?.length) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            component: 'Banner/1up/Standard/Short/Short.js',
            message: 'No entries provided for ShortBanner',
        });
        return <></>;
    }
    useStyles(styles);
    const handleClick = universalHandleClick(salesforceResponse);
    const backgrounds = {
        desktop: data.background_image?.desktop?.url,
        tablet: data.background_image?.tablet?.url, // can add fallbacks easily this way
        mobile: data.background_image?.mobile?.url,
    };
    const device = (matches) => Object.keys(matches).find((key) => matches[key]); // returns device type string
    const imageQuality = '?auto=webp';

    const getMessageText = (value) => (typeof value === 'string' ? value.trim() : '');
    const hasMessage = (message) => {
        const heading = getMessageText(message?.heading) || getMessageText(message?.content?.heading?.text);
        const subHeading = getMessageText(message?.sub_heading) || getMessageText(message?.content?.sub_heading?.text);
        return Boolean((heading && subHeading) || (heading || subHeading));
    };

    const renderBanner = (matches) => (
        <div style={{ backgroundImage: `url(${backgrounds[device(matches)]}${imageQuality})` }} className={styles.backgroundImageContainer}>
            {hasMessage(data?.message) && <MessageStandard data={data?.message} fullBackground bannerType="shortBanner" />}
            <picture>
                <source srcSet={`${backgrounds[device(matches)]}${imageQuality}`} />
                {backgrounds[device(matches)] && <img src={`${backgrounds[device(matches)]}${imageQuality}`} alt="background image" height="0" width="0" />}
            </picture>
        </div>
    );
    const bannerLink = data?.message?.cta?.link?.href || false;
    const bannerLinkText = !!data?.message?.cta?.title;

    return (
        <ConditionalWrapper
            condition={!hasMessage(data?.message) && !bannerLinkText && bannerLink}
            wrapper={(children) => <Link to={bannerLink} aria-label={data.background_image?.desktop?.title}>{children}</Link>}
        >
            <div data-testid="shortBanner" role="presentation" onClick={() => handleClick(data.message.cta)} className={bannerLink?.href && bannerLink?.title ? styles.shortBannerContainer : ''}>
                <ResponsiveWrapper renderer={renderBanner} />
            </div>
        </ConditionalWrapper>
    );
};
ShortBanner.propTypes = {
    data: object.isRequired,
    salesforceResponse: object,
};
ShortBanner.defaultProps = {
    salesforceResponse: {},
};
export default ShortBanner;
